import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import ContractList from "./ContractList";
export default function Container({ updater }) {
  return (
    <>
      <Header updater={updater}></Header>

      <div className="main-layout mx-sm-5">
        <ContractList></ContractList>
      </div>
      <Footer className="mt-5"></Footer>
    </>
  );
}
